import { packBit } from "@/services/Utility";

export const getCondensedBudgetColumnDefault = (): number => {
  let columns = 0;
  columns = packBit(columns, true, BudgetColumns.totalThisDraw.bit);
  columns = packBit(columns, true, BudgetColumns.totalThisEquity.bit);
  columns = packBit(columns, true, BudgetColumns.percentDrawn.bit);
  columns = packBit(columns, true, BudgetColumns.percentInspectedThisDraw.bit);
  columns = packBit(columns, true, BudgetColumns.totalDrawnToDate.bit);
  columns = packBit(columns, true, BudgetColumns.percentInspected.bit);
  columns = packBit(columns, true, BudgetColumns.fundsAvailable.bit);

  return columns;
};

export const BudgetColumns = {
  initialBudget: { bit: 0, alwaysVisible: false, label: "Initial Budget" },
  budgetAmount: { bit: 1, alwaysVisible: false, label: "Budget Amount" },
  cumulativeAdjustment: { bit: 2, alwaysVisible: false, label: "Cumulative Adjustment" },
  priorDrawnToDate: { bit: 3, alwaysVisible: false, label: "Prior Drawn To Date" },
  totalThisDraw: { bit: 4, alwaysVisible: false, label: "This Draw Loan" },
  totalThisEquity: { bit: 5, alwaysVisible: false, label: "This Draw Equity" },
  netThisDraw: { bit: 6, alwaysVisible: false, label: "Net This Draw Loan" },
  priorEquityToDate: { bit: 7, alwaysVisible: false, label: "Prior Equity To Date" },
  percentDrawn: { bit: 8, alwaysVisible: false, label: "% Draw" },
  percentInspectedThisDraw: { bit: 9, alwaysVisible: false, label: "This Draw Insp" },
  projectedOver: { bit: 10, alwaysVisible: false, label: "Projected Over / (Under)" },
  drawnToDate: { bit: 11, alwaysVisible: false, label: "Loan Drawn To Date" },
  netThisDrawEquity: { bit: 12, alwaysVisible: false, label: "Net This Draw Equity" },
  equityToDate: { bit: 13, alwaysVisible: false, label: "Equity Drawn To Date" },
  totalDrawnToDate: { bit: 14, alwaysVisible: false, label: "Total Drawn To Date" },
  percentInspectedPriorDraw: { bit: 15, alwaysVisible: false, label: "Insp Prior Draw" },
  percentBudget: { bit: 16, alwaysVisible: true, label: "" },
  percentInspected: { bit: 17, alwaysVisible: false, label: "Total Insp" },
  variance: { bit: 18, alwaysVisible: false, label: "Variance" },
  fundsAvailable: { bit: 19, alwaysVisible: false, label: "Funds Available" },
  fundsRequired: { bit: 20, alwaysVisible: false, label: "Funds Required" },
  hccPercent: { bit: 21, alwaysVisible: false, label: "HCC %" },
  totalRetainagePriorDraw: { bit: 22, alwaysVisible: false, label: "Total Retainage Prior Draws" },
  totalReleasedPriorDraw: { bit: 23, alwaysVisible: false, label: "Total Released Prior Draws" },
  totalRetainage: { bit: 24, alwaysVisible: false, label: "Total Retainage" },
  totalReleased: { bit: 25, alwaysVisible: false, label: "Total Released" },
  retainageBalance: { bit: 26, alwaysVisible: false, label: "Retainage Balance" },
  cutChecks: { bit: 27, alwaysVisible: false, label: "Cut Checks" },
  delete: { bit: 28, alwaysVisible: true, label: "" },
  history: { bit: 29, alwaysVisible: true, label: "" },
  lineRefNumber: { bit: 30, alwaysVisible: true, label: "Line #" },
  description: { bit: 31, alwaysVisible: true, label: "Description" },
  custCostType: { bit: 32, alwaysVisible: true, label: "Category" },
  costType: { bit: 33, alwaysVisible: true, label: "Cost Type" },
  budgetAdjustment: { bit: 34, alwaysVisible: true, label: "Budget Adjustment" },
  adjustedBudget: { bit: 35, alwaysVisible: true, label: "Adjusted Budget" },
};
